import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { http } from "../../axios/axios";
import { GetImageUrl } from "../../helpers/GetImageUrl";
import SectionHeader from "../SectionHeader";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import ServiceCard from "./ServiceCard";

const HomeServices = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServices = async () => {
    try {
      setLoading(true);

      const { data } = await http.get("/services");

      setServices(data?.data || []);
    } catch (error) {
      console.error("Failed to load services:", error);
      setServices([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section className="py-16 bg-white">
        <div className="text-center text-sm text-slate-500">
          Loading services...
        </div>
      </section>
    );
  }

  if (!services.length) {
    return null;
  }

  return (
     <section className="px-4 sm:px-6 lg:px-8 py-5 md:py-6">
      <SectionHeader
        badge="Our Services"
        title="Professional Security Services"
        description={
          <span className="lg:whitespace-nowrap">
            Explore our professional security surveillance and IT product services
            designed for homes, businesses and organizations.
          </span>
        }
        showLine={true}
        sideTitle={null}
        sideSubtitle={null}
      />

      {loading ? (
        <div className="flex justify-center py-20">
          <div className="h-12 w-12 animate-spin rounded-full border-b-2 border-blue-700" />
        </div>
      ) : services.length > 0 ? (
        <Swiper
          modules={[Autoplay, Pagination]}
          spaceBetween={24}
          speed={800}
          loop={services.length > 3}
          autoplay={
            services.length > 3
              ? {
                  delay: 5000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                }
              : false
          }
          pagination={{
            clickable: true,
          }}
          breakpoints={{
            0: {
              slidesPerView: 1,
              spaceBetween: 16,
            },

            640: {
              slidesPerView: 2,
              spaceBetween: 20,
            },

            1024: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
          }}
          className="pb-12"
        >
          {services.map((service, index) => (
            <SwiperSlide
              key={service._id || index}
              className="h-auto p-6"
            >
              <ServiceCard
                service={service}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <div
          className="
            py-20
            text-center
            border
            border-dashed
            border-slate-300
            rounded-2xl
            bg-slate-50
          "
        >
          <Box
            size={40}
            className="mx-auto text-slate-300 mb-4"
          />

          <h3 className="text-lg font-semibold text-slate-700 mb-2">
            No Services Available
          </h3>

          <p className="text-sm text-slate-500">
            We are currently updating our Services. Please check back soon.
          </p>
        </div>
      )}
    </section>
   /*  <section className="bg-white px-4 py-10 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-[1500px]">

        // Heading 
        <div className="mb-10 text-center">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-blue-600">
            Our Services
          </span>

          <h2 className="mt-3 text-3xl font-bold text-slate-900 md:text-4xl">
            Professional Security Services
          </h2>

          <p className="mx-auto mt-4 max-w-2xl text-sm leading-6 text-slate-600 md:text-base">
            Explore our professional security surveillance and IT product services
            designed for homes, businesses and organizations.
          </p>
        </div>

        // Service Cards  
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {services.slice(0, 8).map((service) => (
            <Link
              key={service._id}
              to={`/services/${service.slug}`}
              className="
                group
                overflow-hidden
                rounded-xl
                border
                border-slate-200
                bg-white
                transition-all
                duration-300
                hover:-translate-y-1
                hover:border-blue-300
                hover:shadow-xl
              "
              
            >
              // Image 
              <div className="h-64 overflow-hidden bg-slate-100">
                <img
                  src={GetImageUrl(
                    service.sectionImage || service.bannerImage
                  )}
                  alt={
                    service.sectionAlt ||
                    service.bannerAlt ||
                    service.bannerTitle
                  }
                  style={{ height: "250px", width: "350px" }}
                  className="
                    h-full
                    w-full
                    object-cover
                    object-center
                    transition-transform
                    duration-500
                    group-hover:scale-105
                  "
                />
              </div>

              // Content 
              <div className="p-5">
                <h3 className="text-lg font-bold text-slate-900 transition-colors group-hover:text-blue-600">
                  {service.bannerTitle}
                </h3>

                {service.bannerSubtitle && (
                  <p
                    className="mt-3 text-sm leading-6 text-slate-600"
                    style={{
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 3,
                      overflow: "hidden",
                    }}
                  >
                    {service.bannerSubtitle}
                  </p>
                )}

                <div className="mt-5 flex items-center gap-2 text-sm font-semibold text-blue-600">
                  View Service

                  <ArrowRight
                    size={16}
                    className="transition-transform duration-300 group-hover:translate-x-1"
                  />
                </div>
              </div>
            </Link>
          ))}
        </div>

        // View All 
        <div className="mt-10 text-center">
          <Link
            to="/services"
            className="
              inline-flex
              items-center
              gap-2
              rounded-lg
              bg-blue-600
              px-6
              py-3
              text-sm
              font-semibold
              text-white
              transition
              hover:bg-blue-700
            "
          >
            View All Services
            <ArrowRight size={17} />
          </Link>
        </div>

      </div>
    </section> */
  );
};

export default HomeServices;